import React from "react";
import './style.scss'

const Spinner = () => {
    return (
        <div className='spinner'>
            <div className="spinner__wrapper">
                <div/>
                <div/>
                <div/>
                <div/>
                <div/>
                <div/>
                <div/>
                <div/>
                <div/>
                <div/>
                <div/>
                <div/>
            </div>
        </div>
    )
}

export default Spinner;